<template>
  <div class="rail-transit-equipment-management-system">
    <top-nav :banner="data.banner" isParent></top-nav>
    <pain></pain>
    <management-advantages></management-advantages>
    <scope-of-application></scope-of-application>
    <comm-scene :dataKey="'rail-transit-equipment-management-system'"></comm-scene>
    <product-list></product-list>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FeatureGrid from '@/views/plan-view/smart-solid-waste-transportation-management/components/feature-grid.vue';
import ManagementAdvantages from './components/management-advantages.vue';
import ScopeOfApplication from './components/scope-of-application.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';
import Pain from './components/pain.vue';

export default {
  components: {
    Pain,
    FeatureGrid,
    ManagementAdvantages,
    ScopeOfApplication,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['rail-transit-equipment-management-system'] || { banner: [] };
    }
  }
};
</script>

<style lang="scss" scoped>
.rail-transit-equipment-management-system {
  background: #ffffff;

  ::v-deep .banner-item-title {
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  }

  ::v-deep .banner-item-brief {
    width: 56%;
    font-size: 22px;
    line-height: 1.5;
    color: white!important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
  }

  ::v-deep .banner-list .banner-item .banner-buttons {
    bottom: 18%;
  }

  ::v-deep .management-advantages {
    .card-list {
      flex-wrap: nowrap;
    }
    .card-item {
      width: calc(100%  / 5);
      overflow: hidden;
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
      }
    }
    .card-image {
      display: block;
      width: 100%;
      height: 160px;
      object-fit: cover;
    }
    .card-title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: 18px;
      color: #333333;
      line-height: 24px;
    }

    .card-description {
      margin-top: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #909399;
      line-height: 18px;
    }
  }
}
</style>
